import { render, staticRenderFns } from "./MessageModalContent.vue?vue&type=template&id=1a5ff296&scoped=true&"
import script from "./MessageModalContent.vue?vue&type=script&lang=js&"
export * from "./MessageModalContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageModalContent.vue?vue&type=style&index=0&id=1a5ff296&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ff296",
  null
  
)

export default component.exports